export default class GlobalVar{ //Variaveis Globais
  static serverIp = ''
  static serverPort = '' //3341

  static getLocalStorage(chave){
    let valor = sessionStorage.getItem(chave)
    return valor !== "undefined" && valor ? JSON.parse(valor) : null
  }

  static setLocalStorage(chave, valor){
    return sessionStorage.setItem(chave,JSON.stringify(valor));
  }

  static lojas = {
    Rosa: {
      title: 'Rosa',
      telefone: '(31) 3275-8905',
      celular: '5531986524605',
      endereco: <>{'Rua Mato Grosso, 481 - Barro Preto'} <br/> {'Belo Horizonte - MG - CEP: 30190-080'}</>,
      cor: '#FF0073'
    },
    Royal: {
      title: 'Royal',
      telefone: '(31) 3275-8921',
      celular: '553186524608',
      endereco: <>{'Rua Mato Grosso, 538 - Barro Preto'} <br/> {'Belo Horizonte - MG - CEP: 30190-920'}</>,
      cor: '#4DB0CF'
    },
    Azul: {
      title: 'Azul',
      telefone: '(31) 3275-8908',
      celular: '5531986524604',
      endereco: <>{'Av. Augusto de Lima, 1143 - Barro Preto'} <br/> {'Belo Horizonte - MG - CEP: 30190-002'}</>,
      cor: '#284CD9'
    },
    Outlet: {
      title: 'Outlet',
      telefone: '(31) 3270-7019',
      celular: '5531986524621',
      endereco: <>{'Av. Augusto de Lima, 1131 - Barro Preto '} <br/> {'Belo Horizonte - MG - CEP: 30190-080'}</>,
      cor: '#FF8F00'
    },
  }


  static vantagemList = [
    {
      title: 'Pedidos Online e por Telefone',
      image: 'bolsaIcon.png'
    },
    {
      title: 'Lançamento de Revista Mensal',
      image: 'calendar.png'
    },
    {
      title: '4 Lojas de alto nível',
      image: 'map.png'
    },
    {
      title: 'Prazo e Pagamento Facilitado',
      image: 'pagamento.png'
    },
    {
      title: 'Troca Facilitada',
      image: 'coracao.png'
    },
    {
      title: 'Marcas Exclusivas',
      image: 'fashionClub.png'
    }
  ]

}

